import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { priceNormelizer } from "../../helpers/tags";
import { stringEquals } from "../../helpers/string-helpers";

class PriceDisplay extends React.Component {
  convert = () => {
    const {
      price,
      selectedCurrencyCode,
      currentCurrencyCode,
      fallBackCurrencySymbol,
      currencies
    } = this.props;
    if (
      !selectedCurrencyCode ||
      !currentCurrencyCode ||
      !currencies ||
      !currencies.length
    ) {
      return priceNormelizer`${fallBackCurrencySymbol}${price}`;
    }

    const selectedCurrencyObj = currencies.find(cur =>
      stringEquals(cur.currencyCode, selectedCurrencyCode)
    );

    let currenctCurrencyObj = currencies.find(cur =>
      stringEquals(cur.currencyCode, currentCurrencyCode)
    );

    if (
      stringEquals(currentCurrencyCode, "NIS") ||
      stringEquals(currentCurrencyCode, "ILS")
    ) {
      currenctCurrencyObj = currencies.find(
        cur =>
          stringEquals(cur.currencyCode, "NIS") ||
          stringEquals(cur.currencyCode, "ILS")
      );
    }

    const priceInSelectedCurrency =
      selectedCurrencyObj &&
      selectedCurrencyObj.rate !== 0 &&
      currenctCurrencyObj
        ? (price * (currenctCurrencyObj.rate / currenctCurrencyObj.unit)) /
          (selectedCurrencyObj.rate / selectedCurrencyObj.unit)
        : price;

    const normalizedPrice = priceNormelizer`${
      selectedCurrencyObj ? selectedCurrencyObj.symbol : fallBackCurrencySymbol
    }${priceInSelectedCurrency}`;
    return normalizedPrice;
  };
  render() {
    const { children } = this.props;
    const convertedPrice = this.convert();
    return children(convertedPrice);
  }
}

PriceDisplay.propTypes = {
  currencies: PropTypes.array,
  price: PropTypes.number,
  selectedCurrencyCode: PropTypes.string,
  currentCurrencyCode: PropTypes.string,
  fallBackCurrencySymbol: PropTypes.string,
  children: PropTypes.func
};

const mapStateToProps = store => {
  return {
    selectedCurrencyCode: store.selectedCurrency,
    currencies: store.currencies
  };
};

export default connect(mapStateToProps)(PriceDisplay);

{
  /* <PriceDisplay>
{convertedPrice => <div>{convertedPrice}</div>}
</PriceDisplay> */
}



// WEBPACK FOOTER //
// ./src/containers/PriceDisplay/PriceDisplay.js